import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { EngagementsSection } from '../components/EngagementsSection';
import { ExecutionScopeSection } from '../components/ExecutionScopeSection';
import { FitFilterSection } from '../components/FitFilterSection';
import { ContactSection } from '../components/ContactSection';
export function LandingPage() {
  return <div className="min-h-screen bg-white text-black font-sans selection:bg-gray-200" data-id="element-159">
      <Header data-id="element-160" />
      <main data-id="element-161">
        <HeroSection data-id="element-162" />
        <AboutSection data-id="element-163" />
        <HowItWorksSection data-id="element-164" />
        <EngagementsSection data-id="element-165" />
        <ExecutionScopeSection data-id="element-166" />
        <FitFilterSection data-id="element-167" />
        <ContactSection data-id="element-168" />
      </main>

      <footer className="py-12 border-t border-gray-100" data-id="element-169">
        <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center text-xs text-gray-400 uppercase tracking-widest" data-id="element-170">
          <p data-id="element-171">&copy; {new Date().getFullYear()} Brittney Gwynn.</p>
        </div>
      </footer>
    </div>;
}